// PR 53 fixes · fork P — F11 (B34-11): the error of the viewer's "linked documents by id" route. EN + AR.
export const I18N_B34P = {
  en: {
    errors: {
      VOUCHING_VIEW_TOO_MANY_IDS: "At most 500 documents can be opened at once.",
    },
  },
  ar: {
    errors: {
      VOUCHING_VIEW_TOO_MANY_IDS: "يمكن فتح 500 مستند كحد أقصى في المرة الواحدة.",
    },
  },
};

export default I18N_B34P;
